import { Component, Input } from '@angular/core'
import { HideZeroValuesPipe } from '../../../common/hide-zero-values.pipe'
import {
  openCloseWidget,
  openCloseWidgetContent,
  openCloseWidgetHeader,
} from '../../../utils/animations'
import { ContextService } from '../../../services'

@Component({
  standalone: false,
  selector: 'app-mobility-legend-widget',
  templateUrl: './legend-widget.component.html',
  styleUrls: ['./legend-widget.component.scss'],
  animations: [openCloseWidget, openCloseWidgetHeader, openCloseWidgetContent],
})
export class MobilityLegendWidgetComponent {
  @Input() type: 'ramp' | 'line' = 'ramp'
  @Input() colors: string[] = []
  @Input() title = ''
  @Input() subtitle = ''
  @Input() labels: string[] = []
  @Input() titleExtra: string
  @Input() showDensity = false
  widgetCollapsed = false

  modeOptions = [
    { value: 'classic', label: 'Classic' },
    { value: 'density', label: 'By Density' },
  ]
  selectedMode = this.modeOptions[0]

  constructor(
    private hideZeroValues: HideZeroValuesPipe,
    private context: ContextService,
  ) {
    if (this.context.isDensityActive()) {
      this.selectedMode = this.modeOptions[1]
    }
  }

  parse(label) {
    return isNaN(label) ? label : this.hideZeroValues.transform(label, '1.0-0')
  }

  toggleWidget() {
    this.widgetCollapsed = !this.widgetCollapsed
  }

  changeMode($event) {
    this.selectedMode = $event
    if ($event.value === 'density') {
      this.context.toggleDensityMode()
    } else {
      if (this.context.isDensityActive()) {
        this.context.toggleDensityMode()
      }
    }
  }
}
